export const newsDB = [
    {
          _id: 0,
        img: 'https://www.virology.ws/wp-content/uploads/2009/04/influenza-virion3.jpg',
        title: 'Influenza',
        description: 'About the flu and how to prevent it.'
    },
    {
          _id: 1,
        img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQEJfQzZpKQeFMckcD_HRLmO8B4FgOpPhYt9Q&usqp=CAU',
        title: 'COVID-19',
        description: 'SARS-CoV-2 can infect the inner ear.'
    },
    {
          _id: 2,
          img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ9jdWmg13XD54pnu7Knvw676FyY3AQL5upCQ&usqp=CAU',
        title: 'Acute Promyelocytic Leukemia',
        description: 'Trial shows conventional chemotherapy can be avoided in some kids.'
    },
    {
          _id: 3,
          img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQlvBDZkj4TdZj_BZ2dzRgA2dEJZbq5N_0EuAdJ16JYe7fpOuqGZQbQVSvDDvLEKA3_Ajc&usqp=CAU',
        title: 'NIH Director',
        description: 'Francis Collins to step down as director of the National Institutes of Health.'
    }
]

